<template>
  <div class="onlineExhibition">
    <div class="swiper">
      <img src="@/assets/images/detail/back_white.png" alt="" class="back" />
      <van-swipe @change="onChange">
        <van-swipe-item v-for="item in 5"> <img src="@/assets/images/detail/culturalCollection/swiper.png" alt="" class="swiper_img" /> </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/5</div>
        </template>
      </van-swipe>
    </div>
    <div class="introduction">
      <div class="d-f jc-sb ai-c">
        <span class="title">广州体育馆足球场</span>
      </div>
      <div class="venue d-f jc-sb ai-c">
        <span class="title">所属场馆：浙江省博物馆</span>
      </div>
      <div class="common_msg date d-f ai-c">
        <img src="@/assets/images/detail/address.png" alt="" class="icon" />
        <span>地址：杭州市西湖区浙江省博物馆 2楼20</span>
        <img src="@/assets/images/detail/address1.png" alt="" class="address1" />
      </div>
      <div class="link"></div>
      <div class="opening-hours">开放时间：上午9:00:00~12:00</div>
      <div class="link"></div>
      <div class="contacts">联系人：张三</div>
      <div class="contact-information">联系方式：15797876623</div>
      <div class="link"></div>

      <div class="area"><span>场地面积：</span><span class="bold">100m²</span></div>
      <div class="area"><span>最多容纳：</span><span class="bold">25人</span></div>
      <div class="facilities"><span>场地设施：</span><span class="bold">户外藤编桌椅</span></div>
      <div class="link"></div>
      <div class="d-f jc-sb ai-c m-t">
        <span class="title">场馆简介</span>
      </div>
      <div class="common_details">
        广东省文化馆是广东省人民政府设立的专门从事辅导、指导、研究群众文化艺术活动和培训业务骨干，为广大人民群众提供公共文化服务的事业机构。截至2018年12月，广东省文化馆为社会艺术水平考级机构。
        <span class="more">展开<img src="@/assets/images/detail/more.png" alt="" class="more-img" /></span>
      </div>
    </div>
    <div class="handle_button d-f jc-sb ai-c">
      <div class="d-f ai-c">
        <div class="handle_item d-f ai-c border_right">
          <img src="@/assets/images/detail/performance/circle_share.png" alt="" class="icon_handle" />
          <span style="white-space: pre-wrap; display: inline-block; width: 30px">分享</span>
        </div>
      </div>
      <div class="btn">入馆预约</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'onlineExhibition',
  data() {
    return { current: 0, tabs: ['详情介绍', '展览展示'], tabIndex: 0 }
  },
  methods: {
    onChange(index) {
      this.current = index
    },
    changeTab(index) {
      if (index !== this.tabIndex) {
        this.tabIndex = index
      }
    },
    goDetail() {
      this.$router.push({
        path: '/detail/exhibitionDetail',
        query: {
          id: 88,
        },
      })
    },
  },
  created() {},
  mounted() {},
}
</script>
<style lang="scss">
.onlineExhibition {
  width: 100%;
  height: 100vh;
  background: #fff;

  .collect_button {
    padding-top: 0.6rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2.4rem;
    .collect {
      font-size: 0.7rem;
      font-weight: 400;
      color: #212121;
      img {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 8px;
      }
    }
  }
  .swiper {
    width: 100%;
    height: 12.5rem;
    .back {
      z-index: 1;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      // top: 0.5rem;
      top: calc(0.5rem + env(safe-area-inset-top));
    }

    .swiper_img {
      width: 100%;
      height: 100%;
    }
    .custom-indicator {
      position: absolute;
      height: 0.95rem;
      line-height: 0.95rem;
      right: 8px;
      bottom: 8px;
      padding: 0 9px;
      font-size: 0.6rem;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 0.5rem;
    }
  }
  .introduction {
    padding: 0.8rem 0;
    margin: 0 0.6rem;
    // border-bottom: 1px solid #f4f4f4;
    .venue {
      .title {
        height: 1.1rem;
        font-size: 0.7rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 1.1rem;
      }

      margin-top: 0.6rem;
    }
    .link {
      //   height: 1px;
      border: 1px dotted #eeeeee;
    }

    .area {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-bottom: 0.45rem;
      margin-top: 0.55rem;
      .bold {
        font-weight: 600;
        color: #333333;
      }
    }
    .accommodate {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-bottom: 0.45rem;
      .bold {
        font-weight: 600;
        color: #333333;
      }
    }
    .m-t {
      margin-top: 1.2rem;
    }
    .common_details {
      margin-top: 0.6rem;
      height: 4rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 1rem;
      .more {
        color: #47988a;
        // display: flex;
        // align-items: center;
        line-height: 1rem;
        .more-img {
          padding-top: 0.2rem;
          width: 0.6rem;
          height: 0.6rem;
        }
      }
    }
    .facilities {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-bottom: 0.55rem;
      .bold {
        font-weight: 600;
        color: #333333;
      }
    }

    .contact-information {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-bottom: 0.55rem;
    }
    .contacts {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-top: 0.55rem;
      margin-bottom: 0.4rem;
    }
    .opening-hours {
      height: 0.8rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.8rem;
      margin-top: 0.55rem;
      margin-bottom: 0.55rem;
    }
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .view_total {
      font-size: 0.5rem;
      color: #47988a;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      background: #dff2f2;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
      .address1 {
        width: 1.2rem;
        height: 1.2rem;
        margin-left: 0.8rem;
      }
    }
    .van-swipe2 {
      margin-top: 0.6rem;
      .livePlayback-item {
        display: flex;
        flex-direction: column;
        .livePlayback-img {
          width: 7.2rem;
          height: 4.8rem;
        }
        .text {
          width: 7.2rem;
          height: 1rem;
          font-size: 0.7rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #212121;
          line-height: 1rem;
          margin-top: 0.4rem;
        }
      }
    }
    .common_details {
      margin-top: 0.6rem;
      height: 4rem;
      font-size: 0.7rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 1rem;
      .more {
        color: #47988a;
        // display: flex;
        // align-items: center;
        line-height: 1rem;
        .more-img {
          padding-top: 0.2rem;
          width: 0.6rem;
          height: 0.6rem;
        }
      }
    }
    .common_text {
      margin-top: 0.4rem;
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
    .m-t {
      margin-top: 1.2rem;
    }
  }
  .detail_tabs {
    padding: 0.75rem 0.6rem 0 0.6rem;
    padding-bottom: calc(2.5rem + env(safe-area-inset-bottom));

    .tab_item {
      position: relative;
      font-size: 0.8rem;
      color: #999999;
      line-height: 1.2rem;
      margin-right: 0.8rem;
      &.active {
        font-weight: 600;
        color: #212121;
        &::before {
          content: '';
          display: inline-block;
          width: 1.6rem;
          height: 2px;
          background: #47988a;
          border-radius: 2px;
          position: absolute;
          left: calc(50% - 0.8rem);
          bottom: -4px;
        }
      }
    }
    .content {
      margin-top: 0.9rem;
      .detail_msg {
        font-size: 0.7rem;
        color: #666666;
        line-height: 1rem;
      }
      .exhibition {
        .exhibition_item {
          img {
            width: 8.45rem;
            height: 8.45rem;
            border-radius: 0.5rem;
          }
          .title {
            font-size: 0.7rem;
            font-weight: 600;
            color: #212121;
            line-height: 1rem;
            margin: 0.4rem 0 0.6rem 0;
          }
        }
      }
    }
  }
  .handle_button {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 2.9rem;
    width: 100%;
    background: #fff;
    padding: 0 0.6rem 0 0.6rem;
    font-size: 0.7rem;
    color: #47988a;
    line-height: 1rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    .handle_item {
      // &.border_right {
      //   padding-right: 0.6rem;
      //   position: relative;
      //   ::after {
      //     position: absolute;
      //     content: '';
      //     display: inline-block;
      //     width: 1px;
      //     height: 0.7rem;
      //     top: 0.35rem;
      //     right: 0;
      //     background: #47988a;
      //   }
      // }
      &.border_left {
        padding-left: 0.6rem;
      }
      .icon_handle {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 0.2rem;
      }
    }
    .btn {
      width: 13.75rem;
      text-align: center;
      height: 1.8rem;
      line-height: 1.8rem;
      background: #47988a;
      border-radius: 0.9rem;
      font-size: 0.7rem;
      color: #ffffff;
    }
  }
}
</style>
